import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCore } from "@obg/core.config";
import { ConfigService } from "@obg/ngx.global";
import { CookieService } from "@obg/ngx.global.evo";

@Injectable({
	providedIn: "root",
})
export class ExperimentConfigService {
	constructor(
		private configService: ConfigService<ObgConfigFeAdaptiveClientCore>,
		private cookieService: CookieService
	) {}

	isSBB2BExperimentEnabled(): boolean {
		return (
			this.configService.get((config) => config.core.experiment.isSBB2BExperimentEnabled) &&
			!!this.cookieService.get("obg-experiments")?.includes("sbb2b")
		);
	}

	isSBB2BEnabled(): boolean {
		return this.configService.get((config) => config.core.experiment.isSBB2BEnabled);
	}

	isSBB2CEnabled(): boolean {
		return !!this.cookieService.get("obg-experiments")?.includes("sbb2c");
	}

	isSBB2BMfeEnabled(): boolean {
		return (
			this.configService.get((config) => config.core.experiment.isSBB2BMfeEnabled) ||
			!!this.cookieService.get("obg-experiments")?.includes("sbb2bmfe")
		);
	}

	isSkillGamesRouteEnabled(): boolean {
		return !!this.cookieService.get("obg-experiments")?.includes("skill-games-route");
	}

	isExalogicEnabled(): boolean {
		return (
			this.configService.get((config) => config.core.experiment.isSBExalogicEnabled) ||
			!!this.cookieService.get("obg-experiments")?.includes("sb_exalogic")
		);
	}
}
